import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faHeart, faComment, faDownload } from '@fortawesome/free-solid-svg-icons';
import TagList from '../TagList/TagList';
import CardActions from '../CardActions/CardActions';
import { ImageWithFallback } from '../MediaFallback/MediaFallback';

const Stat = ({ icon, value }) => (
    <span className="inline-flex items-center gap-1.5 text-gray-500 dark:text-gray-400 text-sm">
        <FontAwesomeIcon icon={icon} className="text-brand-400" />
        {value}
    </span>
);

const ImageCardDetails = (props) => {
    const {id, webformatURL, largeImageURL, user, views, likes, comments, downloads} = props.image;
    const tagsSplit = props.image.tags.split(',')
    return (
        <div className="group rounded-xl overflow-hidden shadow-e0 hover:shadow-e2 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 transition-shadow duration-200">
            <div className="relative overflow-hidden h-56">
                <ImageWithFallback
                    src={webformatURL}
                    alt={`by ${user}`}
                    label={`Photo by ${user}`}
                    className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-300"
                />
                {/* dim veil on hover to make the action cluster pop */}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 pointer-events-none" />
                <CardActions
                    kind="image"
                    item={props.image}
                    downloadUrl={largeImageURL || webformatURL}
                    downloadFilename={`pixiy-${id}.jpg`}
                    editUrl={largeImageURL || webformatURL}
                />
            </div>
            <div className="p-4">
                <div className="mb-3">
                    <h3 className="text-gray-900 dark:text-white text-lg font-bold capitalize truncate">
                        Photo by {user}
                    </h3>
                </div>
                <div className="flex flex-wrap gap-x-4 gap-y-2 mb-3">
                    <Stat icon={faEye} value={views} />
                    <Stat icon={faHeart} value={likes} />
                    <Stat icon={faComment} value={comments} />
                    <Stat icon={faDownload} value={downloads} />
                </div>
                <TagList tags={tagsSplit} />
             </div>
         </div>
    );
};

export default ImageCardDetails;
